import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { checkValidity, closeDrawer, handleSwitchInputKeys } from '../../helpers/helpers.js'

const AddVoucher = observer(class AddVoucher extends React.Component {
  constructor() {
    super();
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
  }
  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      voucherData: {
        amount: 0,
        currency: null,
        number: 0,
        tag: null
      }
    }

    SessionStore.getCurrencies();
  }

  handleInput() {
    let voucherData = { ...this.state.voucherData };

    voucherData.amount = this.amount.value || null;
    voucherData.currency = this.currency.value || null;
    voucherData.number = this.number.value || null;
    voucherData.tag = this.tag.value || null;
    if(this.nonTransferable) {
      voucherData.nonTransferable = this.nonTransferable.checked;
    }

    this.setState({
      voucherData
    })
  }

  handleSubmit(e) {
    this.props.store.VoucherStore.createVoucher(this.state.voucherData, this.complete);
  }

  complete() {
    closeDrawer(null, this.props.parent)

    this.props.store.SessionStore.showToaster(this.props.translation.voucher_saved, 'success');
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    return (
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.page_title}</h1>
          </div>
        </header>

        <div className="wrap block-form">
          <form onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
            <div className="panel--medium">
              <fieldset>
                <ul className="fields">
                  <li className="field--auto">
                    <label
                      className="lbl-required"
                      htmlFor="vouchers-amount"
                    >
                      {translation.amount.label}
                    </label>

                    <input
                      type="number"
                      id="vouchers-amount"
                      placeholder="0"
                      ref={(input) => this.amount = input}
                      onChange={this.handleInput}
                      step=".01"
                      required
                      aria-required="true"
                    />

                    <label className="select">
                      <select
                        ref={(input) => this.currency = input}
                        onChange={this.handleInput}
                      >
                        {SessionStore.currencyList.map(
                          (key, i) =>
                            <option key={i} value={key.code}>{key.name}</option>
                        )}
                      </select>
                    </label>
                  </li>
                  <li>
                    <label className="lbl-optional" htmlFor="vouchers-number">{translation.number.label}</label>
                    <input type="number"
                      min="1"
                      id="vouchers-number"
                      placeholder="0"
                      ref={(input) => { this.number = input }}
                      onChange={this.handleInput} />
                  </li>
                  <li>
                    <label className="lbl-optional" htmlFor="vouchers-tag" aria-describedby="vouchers-tag-tooltip">
                      {translation.tag.label}

                      <div className="tooltip">
                        <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                        <div id="vouchers-tag-tooltip" className="tooltip__body" role="tooltip">{translation.tag.tooltip}</div>
                      </div>
                    </label>
                    <input type="text"
                      id="vouchers-tag"
                      ref={(input) => { this.tag = input }}
                      onChange={this.handleInput} />
                  </li>
                  {this.props.single &&
                    <li>
                      <label className="lbl-optional" htmlFor="vouchers-notransfer" aria-describedby="vouchers-notransfer-tooltip">
                        {translation.non_transferable.label}

                        <div className="tooltip">
                          <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                          <div id="vouchers-notransfer-tooltip" className="tooltip__body" role="tooltip">{translation.non_transferable.tooltip}</div>
                        </div>
                      </label>
                      <input 
                        type="checkbox" 
                        id="vouchers-notransfer" 
                        className="switch-input" 
                        value="1"
                        ref={(input) => {this.nonTransferable = input}}
                        onChange={this.handleInput}
                        onKeyDown={handleSwitchInputKeys}
                        checked={this.state.voucherData.nonTransferable} />
                      <label className="switch-label" htmlFor="vouchers-notransfer"><span className="meta">{translation.non_transferable.label}</span></label>
                    </li>
                  }
                </ul>

                <div className="panel__actions actions">
                  <button className="actions__btn actions__btn--primary">{translation.button}</button>
                </div>
              </fieldset>
            </div>
          </form>
        </div>
      </div>
    )
  }
})

export default translate('AddVoucher')(AddVoucher);



// WEBPACK FOOTER //
// ./src/app/components/Vouchers/AddVoucher.js